import { render, staticRenderFns } from "./right-carousel.vue?vue&type=template&id=015ce7a2&scoped=true&"
import script from "./right-carousel.vue?vue&type=script&lang=js&"
export * from "./right-carousel.vue?vue&type=script&lang=js&"
import style0 from "./right-carousel.vue?vue&type=style&index=0&id=015ce7a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ce7a2",
  null
  
)

export default component.exports